import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import LokalizacjaSzukajContainer from "./components/LokalizacjaSzukajContainer";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import KierowcyService from "../../zasobyConfig/kierowcy/KierowcyService";
import PojazdyService from "../../zasobyConfig/pojazdy/PojazdyService";
import LokalizacjaBusowService from "./LokalizacjaBusowService";
import PokazNaMapieLokalizacje from "./googleMapComponents/PokazNaMapieLokalizacje";
import LSService from "../../../../utilities/localStorageService/LSService";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";

export default class LokalizacjaBusowContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            kierowcy: [],
            pojazdy: [],
            params: null,
            lokalizacje: [],
            przekazaneIdKursu: null,
            czyByloSzukanie:false
        };
        this.onClickWyszukaj = this.onClickWyszukaj.bind(this)
        this.onEventOdswiez = this.onEventOdswiez.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
        this.pobierzKierowcow()
        this.pobierzPojazdy()

        if (Boolean(LSService.pobierzIdKursuDoWyszukaniaLokalizacji())) {
            this.setState({
                przekazaneIdKursu: LSService.pobierzIdKursuDoWyszukaniaLokalizacji(),
                params: {
                    trasa: null,
                    kierowca: null,
                    pojazd: null,
                    kurs: LSService.pobierzIdKursuDoWyszukaniaLokalizacji()
                }
            })

            this.onClickWyszukaj({
                trasa: null,
                kierowca: null,
                pojazd: null,
                kurs: LSService.pobierzIdKursuDoWyszukaniaLokalizacji()
            })

            LSService.usunIdKursuDoWyszukaniaLokalizacji()
        }
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({
                trasy: response.data.content
            })
        }.bind(this))
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcy().then(function (response) {
            this.setState({
                kierowcy: Array.from(response.data, item => {
                    return {
                        idKi: item.idKi,
                        imieNazwisko: item.imie + ' ' + item.nazwisko,
                        pesel: item.pesel,
                        nrTel: item.nrTel,
                        status: item.status
                    }
                })
            })
        }.bind(this))
    }

    pobierzPojazdy() {
        PojazdyService.getPojazdy().then(function (response) {
            this.setState({
                pojazdy: Array.from(response.data.content, item => {
                    return {
                        idPo: item.idPo,
                        pojazd: item.marka + ' ' + item.model,
                        nrRej: item.nrRej,
                        pojazdLabel: item.marka + ' ' + item.model + ' ' + item.nrRej,
                        status: item.status
                    }
                })
            })
        }.bind(this))
    }


    onClickWyszukaj(params) {
        this.setState({params: params, lokalizacje: [], czyByloSzukanie:false})


        let url = ''

        if (params.trasa) url = url + 'idTr=' + params.trasa
        if (params.kurs) {
            if (url.length > 0) {
                url = url + '&idKu=' + params.kurs
            } else {
                url = url + 'idKu=' + params.kurs
            }
        }
        if (params.pojazd) {
            if (url.length > 0) {
                url = url + '&idPo=' + params.pojazd
            } else {
                url = url + 'idPo=' + params.pojazd
            }
        }
        if (params.kierowca) {
            if (url.length > 0) {
                url = url + '&idKi=' + params.kierowca
            } else {
                url = url + 'idKi=' + params.kierowca
            }
        }

        LokalizacjaBusowService.pobierzLokalizacjeBusow(url).then(function (response) {

            console.log(response.data)
            if (response) {
                if (response.status < 300) {

                    let arr =[]

                    for(let i=0;i<response.data.length;i++){
                        if(
                            Boolean(response.data[i].idPo) &&
                            Boolean(response.data[i].idKi) &&
                            Boolean(response.data[i].dlGps) &&
                            Boolean(response.data[i].szGps) &&
                            Boolean(response.data[i].idKu)
                        ){
                            arr.push({
                                idLok: i+1,
                                idPo: response.data[i].idPo,
                                nazPo: response.data[i].nazPo,
                                nrRej: response.data[i].nrRej,
                                idKi: response.data[i].idKi,
                                nazKi: response.data[i].nazKi,
                                nrTel: response.data[i].nrTel,
                                idTr: response.data[i].idTr,
                                nazTr: response.data[i].nazTr,
                                idKu: response.data[i].idKu,
                                latlng: {lat: response.data[i].szGps, lng: response.data[i].dlGps},
                                data:response.data[i].data,
                                godz_1p:response.data[i].godz_1p
                            })
                        }
                    }


                    this.setState({lokalizacje: arr, czyByloSzukanie:true})


                }
            }
        }.bind(this))
    }

    onEventOdswiez() {
        if (this.state.params !== null)
            this.onClickWyszukaj(this.state.params)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RozkladContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/rozklad-jazdy',
                                    text: 'Rozkład jazdy'
                                }, {addressUrl: '/konfiguracja/rozklad-jazdy/lokalizacja', text: 'Lokalizacja busów'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <LokalizacjaSzukajContainer trasy={this.state.trasy} kierowcy={this.state.kierowcy} pojazdy={this.state.pojazdy}
                                                        handleClickWyszukaj={this.onClickWyszukaj}
                                                        handleOdswiezDane={this.onEventOdswiez}
                                                        przekazaneIdKursu={this.state.przekazaneIdKursu}
                            />
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                        {
                            Boolean(this.state.lokalizacje.length > 0) ?
                                        <PokazNaMapieLokalizacje lokalizacje={this.state.lokalizacje}/>
                                :
                                Boolean(this.state.czyByloSzukanie)?
                                    <TopAlertUwaga text={'Nie znaleziono busów wedle podanych kryteriów'}/>
                                    :
                                    ''
                        }
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/lokalizacjaBusow/LokalizacjaBusowContainer.js